import { enableProdMode, LOCALE_ID } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { APP_BASE_HREF } from '@angular/common';
import { IS_PD_ALIAS, PD_ALIAS_CANONICAL_LOCALE } from './app/pd-alias-location-strategy';
import { isHomePageAlias, resolveCanonicalLocale } from './app/home-aliases.config';

import { AppModule } from './app/app.module';
import {
  ALL_TRANSLATED_ROUTES,
  CACHE_HOST_OVERRIDE,
  COUNTRY_ID,
  DESKTOP_ROUTE_TOKEN,
  DEVICE_TYPE,
  dirtyMapCmsLocale,
  getLicence,
  HOST_NAME,
  language_license,
  LICENCE,
  LICENCE_CONFIG,
  licences,
  TRANSLATED_ROUTES,
  USER_REGION
} from './app/global.tokens';
import { environment } from './environments/environment';
import { LICENCE_CONFIG_MAP } from './app/config/licence.config';
import { DEVICE_TYPE_MODEL } from './app/apollo/models/base-models';
if (environment.production) {
  enableProdMode();

}
else {

}


const countryFromLocale = (locale) => {
  let splitLocale = locale.split('-');
  return splitLocale.length > 1 ? splitLocale[1] : splitLocale[0];
}

window.addEventListener('beforeinstallprompt', (e: any) => {
  e.preventDefault();
  (window as any).__deferredInstallPrompt = e;
});


document.addEventListener('DOMContentLoaded', () => {
  const pathArray = window.location.pathname.split('/');
  const countryCode = window['countryCode'];
  const userRegion = window['userRegion'];

  const urlFirstSegment = pathArray[1];
  const isPdAlias = isHomePageAlias(urlFirstSegment) && (!pathArray[2] || pathArray[2] === '');
  if (!isPdAlias && urlFirstSegment && /^([a-zA-Z]{2})(-[A-Z]{2})?$/.test(urlFirstSegment)) {
    const baseEl = document.getElementsByTagName('base')[0];
    if (baseEl) {
      baseEl.setAttribute('href', `/${urlFirstSegment}/`);
    }
  }

  let deviceType: DEVICE_TYPE_MODEL;
  if (!window['deviceType']) {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      deviceType = DEVICE_TYPE_MODEL.MOBILE;
    } else {
      deviceType = DEVICE_TYPE_MODEL.DESKTOP;
    }
  }
  else {
    deviceType = window['deviceType'] === 'd' ? DEVICE_TYPE_MODEL.DESKTOP : DEVICE_TYPE_MODEL.MOBILE;
  }
  // deviceType: DEVICE_TYPE_MODEL = DEVICE_TYPE_MODEL.DESKTOP;
  const fallbackLanguage = !!environment.fallbackLanguage ? environment.fallbackLanguage : "en";
  const locale = pathArray[1].match(/^([a-zA-Z]{2})(-[A-Z]{2})?$/gm) ? dirtyMapCmsLocale(pathArray[1]) : dirtyMapCmsLocale(fallbackLanguage);
  let hostnameArray = window.location.hostname.split('.');
  const hostname = hostnameArray.length > 2 ? hostnameArray?.slice(1).join('.') : window.location.hostname;
  // const licenceName = language_license[locale] || licences[hostname] || 'curacao';
  const localLicence = hostname.startsWith('localhost') ? (environment as { localLicence?: string }).localLicence : undefined;
  const licenceName = language_license[locale] || localLicence || getLicence(hostname, locale);

  fetch(`assets/i18n/config.json`).then(response => {
    return response.json();

  })
    .then(data => {
      function renderDevice(desktopRoutes = []) {
        const providers: any[] = [
          { provide: TRANSLATED_ROUTES, useValue: data[locale] || {} },
          { provide: ALL_TRANSLATED_ROUTES, useValue: data },
          { provide: HOST_NAME, useValue: hostname.startsWith("localhost") ? "" : hostname },
          { provide: DESKTOP_ROUTE_TOKEN, useValue: desktopRoutes },
          { provide: LOCALE_ID, useValue: locale },
          { provide: COUNTRY_ID, useValue: countryCode || countryFromLocale(locale) },
          { provide: USER_REGION, useValue: userRegion || '' },
          { provide: LICENCE, useValue: licenceName },
          { provide: DEVICE_TYPE, useValue: deviceType },
          { provide: LICENCE_CONFIG, useValue: { ...{ "default": LICENCE_CONFIG_MAP['default'] }, ...{ "custom": LICENCE_CONFIG_MAP[licenceName] } } },
          { provide: CACHE_HOST_OVERRIDE, useValue: '' },
        ];
        if (isPdAlias) {
          providers.push({ provide: APP_BASE_HREF, useValue: `/${urlFirstSegment}/` });
          providers.push({ provide: IS_PD_ALIAS, useValue: true });
          const canonical = resolveCanonicalLocale(urlFirstSegment);
          if (canonical) {
            providers.push({ provide: PD_ALIAS_CANONICAL_LOCALE, useValue: canonical });
          }
        }
        platformBrowserDynamic(providers).bootstrapModule(AppModule).catch(err => console.log(err));
      }

      if (deviceType === DEVICE_TYPE_MODEL.DESKTOP) {
        import('./app/components/desktop/desktop.module').then(m => m.DesktopModule).then(m => {
          renderDevice(m.routes);
        })
      } else if (deviceType === DEVICE_TYPE_MODEL.MOBILE) {
        renderDevice([]);
      }

      navigator.serviceWorker.getRegistrations().then(function (registrations) {
        console.log("removing service workers", registrations);
        for (let registration of registrations) {
          registration.unregister()
        }
      })
        .catch(err => console.log(err));
    })

});
